import ModuleLanding from '../ecosystem/components/ModuleLanding';

const supportHero = 'https://readdy.ai/api/search-image?query=Professional%20customer%20support%20help%20desk%20environment%2C%20friendly%20support%20agent%20assisting%20customer%20digitally%2C%20warm%20welcoming%20atmosphere%2C%20modern%20tech%20support%20concept%2C%20clean%20minimal%20dark%20background%2C%20professional%20editorial%20photography&width=1600&height=800&seq=support-hero-01&orientation=landscape';

const features = [
  { icon: 'ri-customer-service-2-line', title: 'Tickets & Help Desk', description: 'Créez des tickets par catégorie, suivez leur statut, répondez, fermez et rouvrez. Historique complet conservé.' },
  { icon: 'ri-message-3-line', title: 'Chat Live', description: 'Discutez en temps réel avec les agents support. Indicateurs de saisie, partage de fichiers, images et notes internes.' },
  { icon: 'ri-robot-2-line', title: 'IA Support 24/7', description: 'L\'IA répond d\'abord aux questions fréquentes, suggère des solutions, résume les tickets et escalade automatiquement.' },
  { icon: 'ri-book-open-line', title: 'Base de Connaissances', description: 'Articles, tutoriels, guides, FAQ, vidéos et documentation consultables avec recherche, notes et commentaires.' },
  { icon: 'ri-group-line', title: 'Support Communautaire', description: 'Posez vos questions sur le Forum et recevez des réponses de la communauté. Conversion automatique en ticket si besoin.' },
  { icon: 'ri-calendar-schedule-line', title: 'Automatisation SLA', description: 'Attribution automatique des tickets, règles de priorité, escalades, réponses automatiques et gestion des heures ouvrables.' },
  { icon: 'ri-bar-chart-2-line', title: 'Rapports & Analytics', description: 'Volume de tickets, temps de résolution, satisfaction client, performance des agents et conformité SLA.' },
  { icon: 'ri-shield-keyhole-line', title: 'Sécurité & Permissions', description: 'Rôles définis (Agent, Senior, Team Lead, Admin), 2FA, chiffrement, logs d\'audit et protection anti-spam.' },
  { icon: 'ri-links-line', title: 'Intégration Écosystème', description: 'Support spécialisé pour chaque module : Wallet, Shop, Learn, Work, Cloud, AI, Forum et Jobs.' },
];

const related = [
  { name: 'Forum', path: '/forum', icon: 'ri-discuss-line' },
  { name: 'AI', path: '/ai', icon: 'ri-brain-line' },
  { name: 'Business', path: '/', icon: 'ri-building-2-line' },
  { name: 'Cloud', path: '/cloud', icon: 'ri-cloud-line' },
];

function SupportPage() {
  return (
    <ModuleLanding
      name="Support"
      tagline="Aide. Assistance. Résolution."
      description="WorldApeiron Support est le centre d'aide de l'écosystème. Créez des tickets, discutez en direct avec nos agents, consultez notre base de connaissances ou interagissez avec notre IA support disponible 24h/24."
      heroImageUrl={supportHero}
      features={features}
      ctaText="Contacter le support"
      ctaHref="tel:+22897985849"
      secondaryCta={{ text: 'Base de connaissances' }}
      accentColor="secondary"
      relatedModules={related}
    />
  );
}

export default SupportPage;